import React, { useState, useRef } from 'react';
import {
    View,
    Text,
    ActivityIndicator,
    TextInput,
    TouchableOpacity,
    TouchableWithoutFeedback,
    ScrollView,
    Keyboard,
    SafeAreaView,
    KeyboardAvoidingView,
    Platform,
    Alert,
    Modal,
    Image,
    Dimensions
} from 'react-native';
import * as DocumentPicker from 'expo-document-picker';
import { Ionicons } from '@expo/vector-icons';
import axios from 'axios';
import MaskInput, { Masks } from 'react-native-mask-input'; // Para aplicar máscara no CPF
import Svg, { Path } from 'react-native-svg';
import Checkbox from 'expo-checkbox';

import dadosLocalizacaoLocal from './dadosLocalizacao.json';

import { useLogScreen } from '../../../useLogScreen';

const { width, height } = Dimensions.get('window');

const BackArrowIcon = () => (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <Path d="M18.5489 0.939645C19.151 1.52543 19.151 2.47518 18.5489 3.06097L9.36108 12.0003L18.5489 20.9396C19.151 21.5254 19.151 22.4752 18.5489 23.061C17.9469 23.6468 16.9707 23.6468 16.3686 23.061L5.00049 12.0003L16.3686 0.939645C16.9707 0.353859 17.9469 0.353859 18.5489 0.939645Z" fill="#730d83" />
    </Svg>
);

const DilFormulario = ({ route, navigation }) => {
    useLogScreen('DilFormulario');
    const { usuario_id, emailUser, nomeUser, telefoneUser} = route.params || {};

    const [showCartorioOptions, setShowCartorioOptions] = useState(false);
    const [tipoImovel, setTipoImovel] = useState('');
    const [showTipoOptions, setShowTipoOptions] = useState(false);
    const [cidadeImovel, setCidadeImovel] = useState('');
    const [showCidadeOptions, setShowCidadeOptions] = useState(false);
    const [bairroImovel, setBairroImovel] = useState('');
    const [showBairroOptions, setShowBairroOptions] = useState(false);
    const [enderecoImovel, setEnderecoImovel] = useState('');
    const [showEnderecoOptions, setShowEnderecoOptions] = useState(false);

    const [quantidadeQuartosImovel, setQuantidadeQuartosImovel] = useState('');
    const [showQuantidadeQuartosOptions, setShowQuantidadeQuartosOptions] = useState(false);

    const [quantidadeSuiteImovel, setQuantidadeSuiteImovel] = useState('');
    const [showQuantidadeSuiteOptions, setShowQuantidadeSuiteOptions] = useState(false);

    const [quantidadeVagasImovel, setQuantidadeVagasImovel] = useState('');
    const [showQuantidadeVagasOptions, setShowQuantidadeVagasOptions] = useState(false);

    const [padraoImovel, setPadraoImovel] = useState('');
    const [showPadraoOptions, setShowPadraoOptions] = useState(false);

    const obsRef = useRef(null);
    const [obs, setObs] = useState('');
    const enderecoInputRef = useRef(null);
    const cepInputRef = useRef(null);
    const [cep, setCep] = useState('');
    const complementoInputRef = useRef(null);
    const [complemento, setComplemento] = useState('');

    const metragemInputRef = useRef(null);
    const [metragem, setMetragem] = useState('');

    // dados carregados: inicialmente null (ainda não tentou API)
    const [dadosLocalizacao, setDadosLocalizacao] = useState(null);

    // novos estados para tipos vindos da API (null = ainda não carregado)
    const [tiposDisponiveis, setTiposDisponiveis] = useState(null);

    // estado de carregamento global dos dados de localização/tipos
    const [isLoadingData, setIsLoadingData] = useState(true);

    const gatewayHost = 'https://gateway-laudo.vercel.app';
    const API_BASE = `${gatewayHost}/api/laudo/enderecos/df`;
    const API_TIPOS = `${gatewayHost}/api/laudo/tipos`;
    const API_ESTIMATIVA = `${gatewayHost}/api/laudo/estimativa`;

    const DEBUG_HIST = true; // exibe Alert com a resposta do salvar

    const getLoc = async () => {
        try {
            const { data } = await axios.get(`${API_BASE}`, { timeout: 10000 });
            // Ajustando a resposta para o formato esperado { enderecos: {}, ... }
            return data.enderecos;
        } catch (err) {
            console.error('Erro ao buscar endereços:', err?.message || err);
            return null;
        }
    };

    const getTipos = async () => {
        try {
            const { data } = await axios.get(API_TIPOS, { timeout: 10000 });
            if (data && Array.isArray(data.tipos)) return data.tipos;
            console.warn('Resposta /tipos inesperada', data);
            return null;
        } catch (err) {
            console.error('Erro ao buscar tipos:', err?.message || err);
            return null;
        }
    };

    // ✅ 3) No mount, APLIQUE no estado quando chegar
    React.useEffect(() => {
        let isMounted = true;
        (async () => {
            setIsLoadingData(true);
            try {
                const [locData, tiposData] = await Promise.all([getLoc(), getTipos()]);

                // prioriza resposta da API; se falhar, usa o arquivo estático
                if (isMounted) {
                    if (locData && typeof locData === 'object') {
                        setDadosLocalizacao(locData);
                    } else {
                        setDadosLocalizacao(dadosLocalizacaoLocal);
                    }

                    if (Array.isArray(tiposData)) {
                        setTiposDisponiveis(tiposData);
                    } else {
                        // fallback: mapear tipos estáticos básicos a partir do JSON local (se houver) ou lista vazia
                        setTiposDisponiveis([]);
                    }
                }
            } finally {
                if (isMounted) setIsLoadingData(false);
            }
        })();
        return () => { isMounted = false; };
    }, []);

    const [bairrosDisponiveis, setBairrosDisponiveis] = useState([]);
    const [enderecosDisponiveis, setEnderecosDisponiveis] = useState([]);

    // Validação mínima dos obrigatórios
    const isFormValid = () =>
        Boolean(
            tipoImovel &&
            cidadeImovel &&
            bairroImovel &&
            enderecoImovel &&
            padraoImovel &&
            metragem
        );

    const [isSubmitting, setIsSubmitting] = useState(false);

    // Converte "5 ou +" para número
    const toIntFromOption = (val) => {
        if (!val) return 0;
        const m = String(val).match(/\d+/);
        return m ? parseInt(m[0], 10) : 0;
    };

    // Mapeia o padrão selecionado para o esperado pela API
    const mapPadraoToApi = (label) => {
        if (!label) return null;
        const txt = label.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
        if (txt.startsWith('ORIGINAL')) return 'Original';
        if (txt.startsWith('IMOVEL PADRAO')) return 'Padrão';
        if (txt.startsWith('REFORMADO')) return 'Reformado';
        return 'Padrão';
    };

    const formatBRL = (val) => {
        const n = Number(val);
        if (!Number.isFinite(n)) return '';
        return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 });
    };

    const toIntFloor = (v) => {
        const n = parseFloat(v);
        return Number.isFinite(n) ? Math.floor(n) : 0;
    };

    const pretty = (obj) => {
        try {
            return JSON.stringify(obj, null, 2);
        } catch {
            return String(obj);
        }
    };

    // Salva histórico (tanto em sucesso quanto erro) com logs detalhados
    const salvarHistorico = async (ok, apiData, extras = {}) => {
        try {
            const resultado = apiData?.resultado || {};
            const valorEstimadoStr =
                extras.valorEstimadoStr ??
                (resultado?.formatado_ptbr?.valor_estimado ??
                    (typeof resultado?.valor_estimado !== 'undefined'
                        ? formatBRL(resultado?.valor_estimado)
                        : ''));
            const valorM2Int =
                extras.valorM2Int ?? toIntFloor(resultado?.valor_m2_ponderado);

            const body = {
                nome: (nomeUser || '').trim(),
                email: (emailUser || '').trim(),
                whatsapp: (telefoneUser || '').replace(/\D/g, ''),
                sucess: ok,   // mantém o campo usado pela API
                success: ok,  // envia também a grafia correta por segurança
                json_imovel: {
                    bairro: bairroImovel,
                    cidade: cidadeImovel,
                    endereco: enderecoImovel,
                    estado_conservacao: mapPadraoToApi(padraoImovel) || 'Padrão',
                    tipo: tipoImovel,
                    quartos: toIntFromOption(quantidadeQuartosImovel),
                    suites: toIntFromOption(quantidadeSuiteImovel),
                    vagas: toIntFromOption(quantidadeVagasImovel),
                    metragem: parseFloat(String(metragem).replace(',', '.')),
                    valor_m2_ponderado: valorM2Int,
                    valor_imovel: valorEstimadoStr,
                    valor_estimado: valorEstimadoStr,
                },
                json_user: {
                    nome: (nomeUser || '').trim(),
                    email: (emailUser || '').trim(),
                    whatsapp: (telefoneUser || '').replace(/\D/g, ''),
                },
                json_api: apiData,
                origem: 'mobile-app',
            };

            const resp = await axios.post(
                `${gatewayHost}/api/laudo/historico/salvar`,
                body,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    timeout: 15000,
                }
            );
           
            return resp.data;
        } catch (e) {
   
            return null;
        }
    };

    const handleGerarLaudo = async () => {
        if (!isFormValid()) {
            Alert.alert('Atenção', 'Preencha todos os campos obrigatórios.');
            return;
        }

        const metragemNum = parseFloat(String(metragem).replace(',', '.'));
        if (!metragemNum || Number.isNaN(metragemNum) || metragemNum <= 0) {
            Alert.alert('Atenção', 'Informe uma metragem válida.');
            return;
        }

        const params = {
            cidade: cidadeImovel,
            bairro: bairroImovel,
            endereco: enderecoImovel,
            tipo: tipoImovel,
            limite: 20,
            quartos: toIntFromOption(quantidadeQuartosImovel),
            vagas: toIntFromOption(quantidadeVagasImovel),
            suites: toIntFromOption(quantidadeSuiteImovel),
            metragem: metragemNum,
            estado_conservacao: mapPadraoToApi(padraoImovel),
            tolerancia_m2_pct: 0.1,
            tipo_negocio: 'Venda',
        };

        setIsSubmitting(true);
        try {
            const { data, status } = await axios.get(API_ESTIMATIVA, {
                params,
                headers: { accept: 'application/json' },
                timeout: 15000,
            });

            if (status === 200) {
                const resultado = data?.resultado || {};
                const valorEstimadoStr =
                    resultado?.formatado_ptbr?.valor_estimado ??
                    (typeof resultado?.valor_estimado !== 'undefined'
                        ? formatBRL(resultado?.valor_estimado)
                        : '');
                const valorM2Int = toIntFloor(resultado?.valor_m2_ponderado);

                await salvarHistorico(true, data, { valorEstimadoStr, valorM2Int });
                navigation.navigate('ResultadoDIL', { resultado: data });
            } else {
                await salvarHistorico(false, data || { status });
                Alert.alert('Erro', 'Não foi possível obter a estimativa.');
            }
        } catch (err) {
            console.error('Erro na estimativa:', err?.message || err);
            await salvarHistorico(false, err?.response?.data || { error: err?.message });
            Alert.alert('Erro', 'Falha ao consultar a API de estimativa.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const toggleSouCorretor = () => setsouCorretor(prev => !prev);

    const [souCorretor, setsouCorretor] = useState(false); // OK 

    // 

    const [file, setFile] = useState(null);
    const [fileCorretor, setFileCorretor] = useState(null);
    const [progress, setProgress] = useState(0);
    const [progressCorretor, setProgressCorretor] = useState(0);
    const [isUploading, setIsUploading] = useState(false);

    const pickDocument = async () => {
        const result = await DocumentPicker.getDocumentAsync({
            type: 'image/*',
            copyToCacheDirectory: true,
            multiple: false, // Garante que só 1 imagem seja selecionada
        });

        if (!result.canceled) {
            setFile(result.assets[0]);
            simulateUpload();
        }
    };

    const pickDocumentCorretor = async () => {
        const result = await DocumentPicker.getDocumentAsync({
            type: 'image/*',
            copyToCacheDirectory: true,
            multiple: false, // Garante que só 1 imagem seja selecionada
        });

        if (!result.canceled) {
            setFileCorretor(result.assets[0]);
            simulateUploadCorretor();
        }
    };

    const simulateUpload = () => {
        setIsUploading(true);
        setProgress(0);
        const interval = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 1) {
                    clearInterval(interval);
                    setIsUploading(false);
                    return 1;
                }
                return prev + 0.05;
            });
        }, 200);
    };
    const simulateUploadCorretor = () => {
        setIsUploading(true);
        setProgressCorretor(0);
        const interval = setInterval(() => {
            setProgressCorretor((prev) => {
                if (prev >= 1) {
                    clearInterval(interval);
                    setIsUploading(false);
                    return 1;
                }
                return prev + 0.05;
            });
        }, 200);
    };

    const removeFile = () => {
        setFile(null);
        setProgress(0);
    };
    const removeFileCorretor = () => {
        setFileCorretor(null);
        setProgressCorretor(0);
    };

    // Não renderiza o formulário até termos decidido os dados (API ou fallback)
    if (isLoadingData) {
        return (
            <SafeAreaView style={styles.safeArea}>
                <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                    <ActivityIndicator size="large" color="#730d83" />
                    <Text style={{ marginTop: 12, color: '#1F2024' }}>Carregando dados...</Text>
                </View>
            </SafeAreaView>
        );
    }

    return (
        <SafeAreaView style={styles.safeArea}>
            <View style={styles.headerContainer}>
                <TouchableOpacity onPress={() => navigation.goBack()} style={styles.backButton}>
                    <BackArrowIcon />
                </TouchableOpacity>
                <Text style={styles.headerTitle} allowFontScaling={false}>
                    Precificador
                </Text>
            </View>
            <Text style={styles.classificacaoText} allowFontScaling={false}>
                Avaliação precisa
            </Text>
            <KeyboardAvoidingView style={{ flex: 1 }} behavior={Platform.OS === 'ios' ? 'padding' : undefined}>
                <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
                    <ScrollView contentContainerStyle={styles.scrollContainer}>
                        <View style={styles.container}>

                            {/* Tipo de imovel (Select personalizado) */}
                            <View style={styles.row}>
                                <Text style={styles.subLabel} allowFontScaling={false}>Tipo de imóvel *</Text>
                                <TouchableWithoutFeedback onPress={() => setShowTipoOptions(!showTipoOptions)}>
                                    <View style={[styles.areaInput, { justifyContent: 'center' }]}>
                                        <Text style={{ color: tipoImovel ? '#1F2024' : '#A9A9A9' }}>
                                            {tipoImovel || 'Selecionar'}
                                        </Text>
                                    </View>
                                </TouchableWithoutFeedback>

                                {showTipoOptions && (
                                    <View style={styles.optionsContainer}>
                                        {(Array.isArray(tiposDisponiveis) && tiposDisponiveis.length > 0
                                            ? tiposDisponiveis.map(t => (t.tipo || '').toUpperCase())
                                            : [
                                                "APARTAMENTO",
                                                "KITNET/STUDIO",
                                                "FLAT/APART-HOTEL",
                                                "CASA",
                                                "RURAL",
                                                "LOTE",
                                                "PRÉDIO",
                                                "LOJA",
                                                "SALA COMERCIAL",
                                                "GALPÃO",
                                            ]
                                        ).map((option) => (
                                            <TouchableOpacity
                                                key={option}
                                                style={styles.optionItem}
                                                onPress={() => {
                                                    setTipoImovel(option);
                                                    setShowTipoOptions(false);
                                                }}
                                            >
                                                <Text style={styles.optionText}>{option}</Text>
                                            </TouchableOpacity>
                                        ))}
                                    </View>
                                )}
                            </View>
                            {/*  */}
                            <View style={styles.row}>
                                <Text style={styles.subLabel} allowFontScaling={false}>Cidade *</Text>
                                <TouchableWithoutFeedback onPress={() => setShowCidadeOptions(!showCidadeOptions)}>
                                    <View style={[styles.areaInput, { justifyContent: 'center' }]}>
                                        <Text style={{ color: cidadeImovel ? '#1F2024' : '#A9A9A9' }}>
                                            {cidadeImovel || 'Selecionar'}
                                        </Text>
                                    </View>
                                </TouchableWithoutFeedback>

                                {showCidadeOptions && (
                                    <View style={styles.optionsContainer}>
                                        {[
                                            "AGUAS CLARAS",
                                            "ALPHAVILLE",
                                            "BRASILIA",
                                            "BRAZLANDIA",
                                            "CANDANGOLANDIA",
                                            "CEILANDIA",
                                            "CRUZEIRO",
                                            "GAMA",
                                            "GUARA",
                                            "NUCLEO BANDEIRANTE",
                                            "PARANOA",
                                            "PLANALTINA",
                                            "RECANTO DAS EMAS",
                                            "RIACHO FUNDO",
                                            "SAMAMBAIA",
                                            "SANTA MARIA",
                                            "SAO SEBASTIAO",
                                            "SETOR INDUSTRIAL",
                                            "SOBRADINHO",
                                            "TAGUATINGA",
                                            "VARJAO",
                                            "VICENTE PIRES",
                                            "VILA ESTRUTURAL",
                                        ].map((option) => (
                                            <TouchableOpacity
                                                key={option}
                                                style={styles.optionItem}
                                                onPress={() => {
                                                    setCidadeImovel(option);
                                                    setShowCidadeOptions(false);
                                                    setBairroImovel('');
                                                    setEnderecoImovel('');
                                                    setBairrosDisponiveis(Object.keys(dadosLocalizacao[option] || {}));
                                                    setEnderecosDisponiveis([]);
                                                }}
                                            >
                                                <Text style={styles.optionText}>{option}</Text>
                                            </TouchableOpacity>
                                        ))}
                                    </View>
                                )}
                            </View>

                            {/*  */}
                            <View style={styles.row}>
                                <Text style={styles.subLabel}>Bairro *</Text>
                                <TouchableWithoutFeedback onPress={() => setShowBairroOptions(!showBairroOptions)}>
                                    <View style={[styles.areaInput, { justifyContent: 'center' }]}>
                                        <Text style={{ color: bairroImovel ? '#1F2024' : '#A9A9A9' }}>
                                            {bairroImovel || 'Selecionar'}
                                        </Text>
                                    </View>
                                </TouchableWithoutFeedback>

                                {showBairroOptions && (
                                    <View style={styles.optionsContainer}>
                                        {bairrosDisponiveis.map((option) => (
                                            <TouchableOpacity
                                                key={option}
                                                style={styles.optionItem}
                                                onPress={() => {
                                                    setBairroImovel(option);
                                                    setShowBairroOptions(false);
                                                    const enderecos = dadosLocalizacao[cidadeImovel]?.[option] || [];
                                                    setEnderecosDisponiveis(enderecos);
                                                    setEnderecoImovel('');
                                                }}
                                            >
                                                <Text style={styles.optionText}>{option}</Text>
                                            </TouchableOpacity>
                                        ))}
                                    </View>
                                )}
                            </View>
                            {/*  */}
                            <View style={styles.row}>
                                <Text style={styles.subLabel}>Endereço *</Text>
                                <TouchableWithoutFeedback onPress={() => enderecoInputRef.current?.focus()}>
                                    <View style={styles.inputContainer}>
                                        <TextInput
                                            ref={enderecoInputRef}
                                            allowFontScaling={false}
                                            style={[styles.areaInput]}
                                            placeholder="Digite o endereço (sugestões aparecerão abaixo)"
                                            placeholderTextColor="#A9A9A9"
                                            value={enderecoImovel}
                                            onFocus={() => setShowEnderecoOptions(true)}
                                            onChangeText={(text) => {
                                                setEnderecoImovel(text);
                                                setShowEnderecoOptions(true);
                                            }}
                                            returnKeyType="done"
                                        />
                                    </View>
                                </TouchableWithoutFeedback>

                                {showEnderecoOptions && (
                                    <View style={styles.optionsContainer}>
                                        {Array.isArray(enderecosDisponiveis) && enderecosDisponiveis.length > 0 ? (
                                            enderecosDisponiveis
                                                .filter((opt) => {
                                                    if (!enderecoImovel) return true;
                                                    return opt.toLowerCase().includes(enderecoImovel.toLowerCase());
                                                })
                                                .slice(0, 50) // limite para evitar lista muito grande
                                                .map((option) => (
                                                    <TouchableOpacity
                                                        key={option}
                                                        style={styles.optionItem}
                                                        onPress={() => {
                                                            setEnderecoImovel(option);
                                                            setShowEnderecoOptions(false);
                                                        }}
                                                    >
                                                        <Text style={styles.optionText}>{option}</Text>
                                                    </TouchableOpacity>
                                                ))
                                        ) : (
                                            <View style={styles.optionItem}>
                                                <Text style={[styles.optionText, { color: '#7A7A7A' }]}>
                                                    {cidadeImovel && bairroImovel ? 'Nenhum endereço disponível' : 'Selecione cidade e bairro primeiro'}
                                                </Text>
                                            </View>
                                        )}
                                    </View>
                                )}
                            </View>
                            {/* CEP */}
                            {/* <View style={styles.row}>
                                <Text style={styles.subLabel} allowFontScaling={false}>CEP (opcional)</Text>
                                <TouchableWithoutFeedback onPress={() => cepInputRef.current?.focus()}>
                                    <View style={styles.inputContainer}>
                                        <MaskInput
                                            ref={cepInputRef}
                                            allowFontScaling={false}
                                            style={styles.areaInput}
                                            placeholder="00000-000"
                                            placeholderTextColor="#A9A9A9"
                                            value={cep}
                                            onChangeText={(masked, unmasked) => setCep(masked)}
                                            keyboardType="numeric"
                                            mask={Masks.ZIP_CODE}
                                        />
                                    </View>
                                </TouchableWithoutFeedback>
                            </View> */}
                            {/* Complemento */}
                            {/* <View style={styles.row}>
                                <Text style={styles.subLabel} allowFontScaling={false}>Complemento (opcional)</Text>
                                <TouchableWithoutFeedback onPress={() => complementoInputRef.current?.focus()}>
                                    <View style={styles.inputContainer}>
                                        <TextInput
                                            ref={complementoInputRef}
                                            allowFontScaling={false}
                                            style={styles.areaInput}
                                            placeholder="Apto, Bloco..."
                                            placeholderTextColor="#A9A9A9"
                                            value={complemento}
                                            onChangeText={setComplemento}
                                        />
                                    </View>
                                </TouchableWithoutFeedback>
                            </View> */}
                            <View style={styles.divider} />
                            {/*  */}
                            <View style={styles.row}>
                                <Text style={styles.subLabel} allowFontScaling={false}>Nº de quartos (opcional)</Text>
                                <TouchableWithoutFeedback onPress={() => setShowQuantidadeQuartosOptions(!showQuantidadeQuartosOptions)}>
                                    <View style={[styles.areaInput, { justifyContent: 'center' }]}>
                                        <Text style={{ color: quantidadeQuartosImovel ? '#1F2024' : '#A9A9A9' }}>
                                            {quantidadeQuartosImovel || 'Selecionar'}
                                        </Text>
                                    </View>
                                </TouchableWithoutFeedback>

                                {showQuantidadeQuartosOptions && (
                                    <View style={styles.optionsContainer}>
                                        {[
                                            "0",
                                            "1",
                                            "2",
                                            "3",
                                            "4",
                                            "5",
                                            "6",
                                            "7",
                                            "8",
                                            "9",
                                        ].map((option) => (
                                            <TouchableOpacity
                                                key={option}
                                                style={styles.optionItem}
                                                onPress={() => {
                                                    setQuantidadeQuartosImovel(option);
                                                    setShowQuantidadeQuartosOptions(false);
                                                }}
                                            >
                                                <Text style={styles.optionText}>{option}</Text>
                                            </TouchableOpacity>
                                        ))}
                                    </View>
                                )}
                            </View>
                            {/*  */}
                            <View style={styles.row}>
                                <Text style={styles.subLabel} allowFontScaling={false}>Nº de suítes (opcional)</Text>
                                <TouchableWithoutFeedback onPress={() => setShowQuantidadeSuiteOptions(!showQuantidadeSuiteOptions)}>
                                    <View style={[styles.areaInput, { justifyContent: 'center' }]}>
                                        <Text style={{ color: quantidadeSuiteImovel ? '#1F2024' : '#A9A9A9' }}>
                                            {quantidadeSuiteImovel || 'Selecionar'}
                                        </Text>
                                    </View>
                                </TouchableWithoutFeedback>

                                {showQuantidadeSuiteOptions && (
                                    <View style={styles.optionsContainer}>
                                        {[
                                            "0",
                                            "1",
                                            "2",
                                            "3",
                                            "4",
                                            "5",
                                            "6",
                                            "7",
                                            "8",
                                            "9",
                                        ].map((option) => (
                                            <TouchableOpacity
                                                key={option}
                                                style={styles.optionItem}
                                                onPress={() => {
                                                    setQuantidadeSuiteImovel(option);
                                                    setShowQuantidadeSuiteOptions(false);
                                                }}
                                            >
                                                <Text style={styles.optionText}>{option}</Text>
                                            </TouchableOpacity>
                                        ))}
                                    </View>
                                )}
                            </View>
                            {/*  */}
                            <View style={styles.row}>
                                <Text style={styles.subLabel} allowFontScaling={false}>Nº de vagas (opcional)</Text>
                                <TouchableWithoutFeedback onPress={() => setShowQuantidadeVagasOptions(!showQuantidadeVagasOptions)}>
                                    <View style={[styles.areaInput, { justifyContent: 'center' }]}>
                                        <Text style={{ color: quantidadeVagasImovel ? '#1F2024' : '#A9A9A9' }}>
                                            {quantidadeVagasImovel || 'Selecionar'}
                                        </Text>
                                    </View>
                                </TouchableWithoutFeedback>

                                {showQuantidadeVagasOptions && (
                                    <View style={styles.optionsContainer}>
                                        {[
                                            "0",
                                            "1",
                                            "2",
                                            "3",
                                            "4",
                                            "5",
                                            "6",
                                            "7",
                                            "8",
                                            "9",
                                        ].map((option) => (
                                            <TouchableOpacity
                                                key={option}
                                                style={styles.optionItem}
                                                onPress={() => {
                                                    setQuantidadeVagasImovel(option);
                                                    setShowQuantidadeVagasOptions(false);
                                                }}
                                            >
                                                <Text style={styles.optionText}>{option}</Text>
                                            </TouchableOpacity>
                                        ))}
                                    </View>
                                )}
                            </View>
                            {/*  */}
                            <View style={styles.row}>
                                <Text style={styles.subLabel} allowFontScaling={false}>Metragem útil *</Text>
                                <TouchableWithoutFeedback onPress={() => metragemInputRef.current?.focus()}>
                                    <View style={styles.inputContainer}>
                                        <TextInput
                                            ref={metragemInputRef}
                                            keyboardType='number-pad'
                                            allowFontScaling={false}
                                            style={styles.areaInput}
                                            placeholder="Informar a metragem útil em m²"
                                            placeholderTextColor="#A9A9A9"
                                            value={metragem}
                                            onChangeText={setMetragem}
                                        />
                                    </View>
                                </TouchableWithoutFeedback>
                            </View>
                            {/*  */}
                            <View style={styles.row}>
                                <Text style={styles.subLabel} allowFontScaling={false}>Padrão atual do imóvel *</Text>
                                <TouchableWithoutFeedback onPress={() => setShowPadraoOptions(!showPadraoOptions)}>
                                    <View style={[styles.areaInput, { justifyContent: 'center' }]}>
                                        <Text style={{ color: padraoImovel ? '#1F2024' : '#A9A9A9' }}>
                                            {padraoImovel || 'Selecionar'}
                                        </Text>
                                    </View>
                                </TouchableWithoutFeedback>

                                {showPadraoOptions && (
                                    <View style={styles.optionsContainer}>
                                        {[
                                            "ORIGINAL, REQUER MUITOS REPAROS",
                                            "IMÓVEL PADRÃO, COM MANUTENÇÃO EM DIA",
                                            "REFORMADO, EM EXCELENTE ESTADO",
                                        ].map((option) => (
                                            <TouchableOpacity
                                                key={option}
                                                style={styles.optionItem}
                                                onPress={() => {
                                                    setPadraoImovel(option);
                                                    setShowPadraoOptions(false);
                                                }}
                                            >
                                                <Text style={styles.optionText}>{option}</Text>
                                            </TouchableOpacity>
                                        ))}
                                    </View>
                                )}
                            </View>
                            {/* <View style={styles.divider} /> */}

                            {/* <View style={styles.row}>
                                <Text style={styles.subLabel} allowFontScaling={false}>Observações (opcional)</Text>
                                <TouchableWithoutFeedback onPress={() => obsRef.current?.focus()}>
                                    <View style={styles.inputContainer}>
                                        <TextInput
                                            ref={obsRef}
                                            style={[styles.areaInput]}
                                            multiline
                                            value={obs}
                                            onChangeText={setObs}
                                            placeholder="Digite as principais características e pontos do imóvel"
                                            placeholderTextColor="#A9A9A9"
                                        />
                                    </View>
                                </TouchableWithoutFeedback>
                            </View> */}
                            {/* <View style={styles.row}>
                                <Text style={styles.subLabel} allowFontScaling={false}>Foto (opcional)</Text>
                                <View style={styles.wrapper}>
                                    <TouchableOpacity style={styles.dropZone} onPress={pickDocument}>
                                        <Text style={styles.dropText}>
                                            <Text style={styles.browse}>Escolha uma foto do imóvel</Text>
                                        </Text>
                                    </TouchableOpacity>

                                    {file && (
                                        <View style={styles.fileInfo}>
                                            <Ionicons name="document-outline" size={Platform.select({ ios: width * 0.055, android: width * 0.05 })} color="#730d83" />
                                            <Text style={styles.fileName}>{file.name}</Text>
                                            <View style={styles.progressBarContainer}>
                                                <View style={[styles.progressBar, { width: `${progress * 100}%` }]} />
                                            </View>
                                            <Text style={styles.percent}>{Math.floor(progress * 100)}%</Text>
                                            <TouchableOpacity onPress={removeFile}>
                                                <Ionicons name="close" size={Platform.select({ ios: width * 0.05, android: width * 0.045 })} color="gray" />
                                            </TouchableOpacity>
                                        </View>
                                    )}
                                </View>
                            </View> */}

                            {/* Checkbox "Não possui condomínio" */}
                            {/* <View style={styles.checkboxRow}>
                                <Checkbox
                                    value={souCorretor}
                                    onValueChange={toggleSouCorretor}
                                    color={souCorretor ? '#730d83' : undefined}
                                />
                                <Text style={styles.checkboxLabel} allowFontScaling={false}>Sou corretor de imóveis</Text>
                            </View> */}

                            {souCorretor && (
                                <View style={[styles.row, styles.mt_10]}>
                                    <Text style={styles.subLabel} allowFontScaling={false}>Adicione uma foto pessoal ou sua logomarca (opcional)</Text>
                                    <View style={styles.wrapper}>
                                        <TouchableOpacity style={styles.dropZone} onPress={pickDocumentCorretor}>
                                            <Text style={styles.dropText}>
                                                <Text style={styles.browse}>Adicione uma foto pessoal ou sua logomarca</Text>
                                            </Text>
                                        </TouchableOpacity>

                                        {fileCorretor && (
                                            <View style={styles.fileInfo}>
                                                <Ionicons name="document-outline" size={Platform.select({ ios: width * 0.055, android: width * 0.05 })} color="#730d83" />
                                                <Text style={styles.fileName}>{fileCorretor.name}</Text>
                                                <View style={styles.progressBarContainer}>
                                                    <View style={[styles.progressBar, { width: `${progressCorretor * 100}%` }]} />
                                                </View>
                                                <Text style={styles.percent}>{Math.floor(progressCorretor * 100)}%</Text>
                                                <TouchableOpacity onPress={removeFileCorretor}>
                                                    <Ionicons name="close" size={Platform.select({ ios: width * 0.05, android: width * 0.045 })} color="gray" />
                                                </TouchableOpacity>
                                            </View>
                                        )}
                                    </View>
                                </View>
                            )}

                            <View style={styles.divider} />
                            <View style={styles.buttonContainer}>
                                <TouchableOpacity
                                    style={[
                                        styles.saveButton,
                                        (!isFormValid() || isSubmitting) && { backgroundColor: '#ccc' },
                                    ]}
                                    onPress={handleGerarLaudo}
                                    disabled={!isFormValid() || isSubmitting}
                                >
                                    <Text style={styles.saveButtonText}>
                                        {isSubmitting ? 'Enviando...' : 'Gerar Laudo'}
                                    </Text>
                                </TouchableOpacity>

                                <TouchableOpacity
                                    style={styles.laterButton}
                                    onPress={() => navigation.navigate('Home', { usuario_id })}
                                >
                                    <Image source={require('../../../assets/icons/home.png')} style={styles.laterIcon} />
                                    <Text style={styles.laterButtonText}>Voltar</Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </ScrollView>
                </TouchableWithoutFeedback>
            </KeyboardAvoidingView>
        </SafeAreaView>
    );
};


const styles = {
    // Upload
    wrapper: {
        paddingVertical: 15,
        width: '100%',
    },
    dropZone: {
        borderWidth: 1,
        borderStyle: 'dashed',
        borderColor: '#A9A9A9',
        paddingVertical: 20,
        paddingHorizontal: 10,
        borderRadius: 10,
        alignItems: 'center',
        backgroundColor: '#F5F5F5',
    },
    dropText: {
        color: '#666',
        fontSize: Platform.select({ ios: width * 0.034, android: width * 0.033 }),
        textAlign: 'center',
    },
    browse: {
        color: '#730d83',
        textDecorationLine: 'underline',
    },
    fileInfo: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 15,
        flexWrap: 'wrap',
        gap: 8,
    },
    fileName: {
        flex: 1,
        color: '#333',
        fontSize: width * 0.035,
    },
    progressBarContainer: {
        flex: 1,
        height: 6,
        backgroundColor: '#E0E0E0',
        borderRadius: 3,
        marginHorizontal: 5,
    },
    progressBar: {
        height: 6,
        backgroundColor: '#730d83',
        borderRadius: 3,
    },
    percent: {
        width: 40,
        fontSize: width * 0.03,
        color: '#666',
        textAlign: 'right',
    },
    // fim upload
    mt_30: {
        marginTop: 30
    },
    mt_20: {
        marginTop: 20
    },
    mt_10: {
        marginTop: 10
    },
    modalWrapper: {
        flex: 1,
        backgroundColor: 'rgba(0,0,0,0.5)',
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 20,
    },

    modalContent: {
        backgroundColor: '#FFFFFF',
        borderRadius: 16,
        padding: 24,
        width: '100%',
        maxWidth: 400,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.3,
        shadowRadius: 8,
        elevation: 5,
    },

    modalButtonGroup: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 24,
    },

    cancelButton: {
        flex: 1,
        marginRight: 8,
        paddingVertical: 12,
        borderRadius: 10,
        backgroundColor: '#E0E0E0',
        alignItems: 'center',
    },

    cancelButtonText: {
        color: '#333',
        fontSize: 15,
        fontWeight: '600',
    },

    // saveButton: {
    //     flex: 1,
    //     marginLeft: 8,
    //     paddingVertical: 12,
    //     borderRadius: 10,
    //     backgroundColor: '#730d83',
    //     alignItems: 'center',
    // },



    // input que abre 

    optionsContainer: {
        backgroundColor: '#F5F5F5',
        borderColor: '#D3D3D3',
        borderWidth: 1,
        borderRadius: 10,
        marginTop: 5,
    },
    optionItem: {
        paddingVertical: 10,
        paddingHorizontal: 15,
    },
    optionText: {
        fontSize: 16,
        color: '#1F2024',
    },

    // 
    subTitulo: {
        fontSize: Platform.select({ ios: width * 0.039, android: width * 0.036, web: width * 0.036 }),
        fontWeight: 'bold',
        color: '#1F2024',
        marginBottom: 10,
        textAlign: 'left',
        // paddingLeft: 20,
    },

    // voltar 
    // voltar 
    headerContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: width * 0.05,
        paddingVertical: height * 0.02,
        backgroundColor: '#F5F5F5',
    },
    headerTitle: {
        fontSize: width * 0.04,
        fontWeight: 'bold',
        color: '#1F2024',
        textAlign: 'center'
    },
    classificacaoText: {
        fontSize: width * 0.035,
        fontWeight: 'bold',
        color: '#1F2024',
        marginBottom: 10,
        textAlign: 'left',
        paddingLeft: 20,
    },
    stepsContainer: {
        flex: 1,
        paddingHorizontal: width * 0.05,
    },
    backButton: {
        position: 'absolute',
        left: 20,
    },
    //
    //
    safeArea: {
        flex: 1,
        backgroundColor: '#F5F5F5',
    },
    scrollContainer: {
        paddingVertical: 20,
        paddingHorizontal: 15,
        alignItems: 'center',
    },
    container: {
        width: '90%',
    },
    row: {
        marginBottom: 20,
        width: '100%',
    },
    subLabel: {
        fontSize: Platform.select({ ios: width * 0.037, android: width * 0.035 }),
        fontWeight: '600',
        color: '#1F2024',
        marginBottom: 10,
    },
    titleLabel: {
        fontSize: Platform.select({ ios: width * 0.057, android: width * 0.055 }),
        fontWeight: '600',
        color: '#1F2024',
        marginBottom: 10,
    },
    orientacaoText: {
        fontSize: Platform.select({ ios: width * 0.033, android: width * 0.035 }),
    },
    optionGroup: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    optionGroupSuite: {
        marginLeft: Platform.select({ ios: width * -0.01, android: width * 0.01 }),
        flexDirection: 'row',
        justifyContent: 'start',
        alignItems: 'start',
    },
    optionButton: {
        borderWidth: 1,
        borderColor: '#E9E9E9',
        borderRadius: 25,
        marginHorizontal: 6,
        backgroundColor: '#E9E9E9',
        width: Platform.select({ ios: width * 0.11, android: width * 0.11 }),
        height: Platform.select({ ios: width * 0.11, android: width * 0.11 }),
        justifyContent: 'center',
        alignItems: 'center',
    },
    selectedOption: {
        backgroundColor: '#730d83',
        borderColor: '#730d83',
    },
    optionText: {
        fontSize: width * 0.029,
        color: '#494A50',
    },
    selectedOptionText: {
        color: '#FFF',
    },
    suitesGroup: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginLeft: Platform.select({ ios: -10, android: 10 }),
        marginTop: 10,
    },
    suitesNumberContainer: {
        width: 34,
        height: 34,
        justifyContent: 'center',
        alignItems: 'center',
        marginHorizontal: 5,
    },
    suitesText: {
        fontSize: width * 0.04,
        color: '#1F2024',
        textAlign: 'center',
    },
    incrementDecrementButton: {
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 25,
        width: 44,
        height: 44,
    },
    incrementDecrementButtonText: {
        fontSize: 20,
        color: '#494A50',
    },
    orientationGroup: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        marginTop: 10,
    },
    orientationButton: {
        borderRadius: 25,
        backgroundColor: '#E9E9E9',
        padding: 10,
        alignItems: 'center',
        width: '30%',
    },
    selectedOptionOrientation: {
        backgroundColor: '#730d83',
    },
    areaRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
        marginBottom: 10
    },
    areaColumn: {
        width: '48%',
    },
    areaInput: {
        borderWidth: 1,
        borderColor: '#D3D3D3',
        borderRadius: 10,
        paddingVertical: 10,
        paddingHorizontal: 15,
        fontSize: 16,
        backgroundColor: '#FFF',
    },

    // modal 

    detalhesWrapper: {
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'nowrap',
        marginTop: 10,
        maxWidth: '100%',  // Definir tamanho máximo para o container
        justifyContent: 'flex-start',
    },
    detalheItem: {
        backgroundColor: '#E9E9E9',
        borderRadius: 20,
        paddingHorizontal: 10,
        paddingVertical: 5,
        marginRight: 8,
    },
    detalheText: {
        color: '#000',
        fontSize: 14,
        maxWidth: Platform.select({ ios: 100, android: 90 }), // Controla a largura máxima do texto
    },
    detalheAddButton: {
        backgroundColor: '#E9E9E9',
        borderRadius: 20,
        paddingHorizontal: 10,
        paddingVertical: 5,
        marginLeft: 8,
    },
    detalheAddText: {
        fontSize: 20,
        color: '#000',
    },
    detalheExtra: {
        backgroundColor: '#730d83',
        borderRadius: 20,
        paddingHorizontal: 10,
        paddingVertical: 5,
        marginLeft: 8,
    },
    detalheExtraText: {
        color: '#FFF',
    },

    // descrição 

    descriptionBox: {
        borderWidth: 1,
        borderColor: '#D3D3D3',
        borderRadius: 10,
        padding: 10,
        backgroundColor: '#F5F5F5',
        minHeight: 50,
        justifyContent: 'center',
    },
    descriptionText: {
        fontSize: 14,
        color: '#494A50',
    },
    placeholderText: {
        color: '#D3D3D3',  // Estilo de placeholder
    },
    descriptionFilled: {
        color: '#1F2024',  // Cor do texto quando preenchido
    },
    helperText: {
        fontSize: 12,
        color: '#7A7A7A',
        marginTop: 5,
    },

    // pagamento 
    divider: {
        height: 1,
        backgroundColor: '#E0E0E0',
        marginVertical: 15,
        width: '100%',
    },

    // valores

    checkboxRow: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 10,
    },
    checkboxLabel: {
        fontSize: 14,
        color: '#7A7A7A',
        marginLeft: 10,
    },

    // salvar 

    areaInput: {
        borderWidth: 1,
        borderColor: '#D3D3D3',
        borderRadius: 10,
        paddingVertical: 10,
        paddingHorizontal: 15,
        fontSize: 16,
        backgroundColor: '#F5F5F5',
    },
    inputContainer: {
        width: '100%',
    },
    checkboxRow: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 10,
    },
    checkboxLabel: {
        fontSize: 14,
        color: '#7A7A7A',
        marginLeft: 10,
    },
    buttonContainer: {
        marginTop: 40, // Ajuste do espaçamento superior
        alignItems: 'center',
    },
    saveButton: {
        backgroundColor: '#730d83',
        paddingVertical: 15,
        paddingHorizontal: width * 0.2, // Mais largura
        borderRadius: 25,
        alignItems: 'center',
        marginBottom: 20,
    },
    saveButtonText: {
        color: '#FFF',
        fontSize: Platform.select({ ios: width * 0.04, android: width * 0.03 }), // Ajuste no tamanho da fonte
        fontWeight: '600',
    },
    laterButton: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    laterIcon: {
        width: 20,
        height: 20,
        marginRight: 8,
    },
    laterButtonText: {
        color: '#730d83',
        fontSize: Platform.select({ ios: width * 0.04, android: width * 0.03 }), // Ajuste no tamanho da fonte
        fontWeight: '600',
    },
};

export default DilFormulario;